"use client";
export { NavbarWrapper as default } from "../../../_Builtin/Navbar";
